import { AddOrEditDeploymentTargetPage } from "./AddOrEditDeploymentTargetPage";
interface AddDeploymentTargetPageProps {
    spaceId: string;
}
export function AddDeploymentTargetPage({ spaceId }: AddDeploymentTargetPageProps) {
    return <AddOrEditDeploymentTargetPage spaceId={spaceId}/>;
}
